import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slice/auth/authSlice";
import blogSlice from "./slice/blog/blogSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    blog: blogSlice,
  },
});
